import React, { Component } from 'react';
import { Button } from 'semantic-ui-react'
import { ref, serverIp, } from '../../../config/constants'
import axios from 'axios'
import * as moment from 'moment';
import * as FbUtils from '../../../Utilities/FireBaseUtils'
import Status from '../../../config/OrderStatusConstants.js'



class SendNotifToClientOnNewDesign extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    sendReminder = () => {
        console.log("dsc9 ++++++++++ sendReminder");
        let firebaseSaveUrl = 'designChat/';
        console.log("dsc91 firebaseSaveUrl:" + firebaseSaveUrl);

         //GET NOTIFKEY
         let notifKey = this.props.order.designImageUrl.substr(this.props.order.designImageUrl.length - 10);
         console.log("notifkey:"+notifKey);

        //GET FB USEKY KEY FOR DESIGN IMAGE URL..
        axios.post(serverIp + 'userdetails/getUserFbKey', {
            apiKey: 'adfdfRRR',
            fbOrderKey: this.props.order.key,
        })
            .then((response) => {
                console.log(response.data);

                if (response.data.phonePlusUserFbKey) {
                    console.log("dsc53 phonePlusUserFbKey:" + response.data.phonePlusUserFbKey);
                    firebaseSaveUrl = firebaseSaveUrl + response.data.phonePlusUserFbKey;
                    console.log("dsc54 firebaseSaveUrl:" + firebaseSaveUrl);

                    //save to firebase
                    var d = new Date();
                    //let newTime = -1 * new Date().getTime();
                    let newTime = new Date().getTime();
                    let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                    let message = {
                        message: "New Design has been added",
                        printbodaAdmin: true,
                        time: newTime,
                        username: 'printboda',
                        imageUrl: this.props.order.designImageUrl,
                        adminEmail: this.props.user.email,
                        dateString: now,
                        orderKey: this.props.order.key,
                        order: this.props.order,
                        firebaseSaveUrl: firebaseSaveUrl,
                        notifKey: notifKey
                    }

                    console.log("dsc56 chatmessage:" + JSON.stringify(message, null, 3));

                    //GET CHAT MESSAGE FIREBASE KEY
                    let newPostKey = ref.child(firebaseSaveUrl).push().key;
                    console.log("dsc57 newPostKey:" + newPostKey);
                    ref.child(firebaseSaveUrl + '/' + newPostKey).set(message);

                    //SEND SMS 
                    this.sendNewDesignMessageSms();
                } else {
                    console.log("ERROR:")
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }


    sendNewDesignMessageSms = () => {

        //GET NOTIFKEY
        let notifKey = this.props.order.designImageUrl.substr(this.props.order.designImageUrl.length - 10);
        console.log("notifkey:"+notifKey);

        //GET FB USEKY KEY FOR DESIGN IMAGE URL..
        axios.post(serverIp + 'design/sendNewDesignMessage', {
            adminEmail: this.props.user.email,
            fbOrderKey: this.props.order.key,
            notifKey: notifKey
        })
            .then((response) => {
                console.log(response.data);

                if (response.data) {
                    console.log("dsc63 sms send reply:" + JSON.stringify(response.data, null, 3));

                    let newTime = new Date().getTime();
                    let now = moment().format('MMMM Do YYYY, h:mm:ss a');

                    let orderUpdates = {
                        designSmsSent: true,
                        designSmsSentBy: this.props.user.email,
                        designSmsSentMilliseconds: newTime,
                        designSmsSentDateString: now,
                        designChatNotifKey: notifKey,
                        designChatOpened:'no',  
                        lastUpdated: now,
                        updatedBy: this.props.user.email,
                        lastUpdatedBy: this.props.user.email
                    }

                    FbUtils.updateOrder(this.props.order.key, orderUpdates);

                  

                } else {
                    console.log("ERROR:");
                    alert("ERROR:" + JSON.stringify(response.data, null, 3));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    render() {
        return (
            <div>
                <Button color='orange' onClick={this.sendReminder}>NOTIFY CLIENT</Button>
                
                </div>
        );
    }
}

export default SendNotifToClientOnNewDesign;


// WEBPACK FOOTER //
// ./src/components/newSite/DesignChat/SendNotifToClientOnNewDesign.js